import { render, staticRenderFns } from "./AddEditWorkcenter.vue?vue&type=template&id=2997415f&"
import script from "./AddEditWorkcenter.vue?vue&type=script&lang=js&"
export * from "./AddEditWorkcenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports